import {useEffect} from '@wordpress/element';

export const useProcessPaymentFailure = (
    {
        event,
        onError,
        isExpress = false,
        responseTypes,
        messageContext = null,
        setPaymentData,
        paymentMethodId,
        activePaymentMethod,
    }) => {
    useEffect(() => {
        const unsubscribe = event((data) => {
            if (data?.processingResponse?.paymentDetails?.ppcpErrorMessage) {
                setPaymentData(null);
                const message = data.processingResponse.paymentDetails.ppcpErrorMessage;
                return {
                    type: responseTypes.ERROR,
                    retry: true,
                    message,
                    messageContext
                }
            }
            if (isExpress && activePaymentMethod === paymentMethodId) {
                if (onError) {
                    onError('');
                }
            }
            return null;
        });
        return () => {
            unsubscribe();
        };
    }, [
        event,
        onError,
        paymentMethodId,
        activePaymentMethod
    ]);
}

export default useProcessPaymentFailure;